export const START = 'start';
export const RULES = 'rules';
export const CHOOSE_CHARACTER = 'choose-character';
export const GAME_IN_PROGRESS = 'game';
export const GAME_IS_OVER = 'results';
